const LIGNES = [
  ["sante_probleme", "sante_details", "Problème de santé"],
  ["traitement", "traitement_details", "Traitement"],
  ["allergies", "allergies_details", "Allergies"],
];

// Lignes médicales renseignées via la fiche : [libellé, texte] ; « Non » est indiqué pour montrer que la question a été posée.
export const santeLignes = (j) => LIGNES.flatMap(([k, d, label]) => {
  if (j?.[k] === "oui") return [[label, j[d] || "Oui"]];
  if (j?.[k] === "non") return [[label, "Non"]];
  return [];
});

export const santeTxt = (j) => santeLignes(j).map(([l, t]) => `${l} : ${t}`).join(" ; ");

// Valeur d'une question santé pour l'export : « Oui – précisions », « Non » ou vide.
export const santeVal = (j, k, d) => (j?.[k] === "oui" ? `Oui${j[d] ? ` – ${j[d]}` : ""}` : j?.[k] === "non" ? "Non" : "");

export const adresseComplete = (adresse, cpVille) => [adresse, cpVille].filter(Boolean).join(", ");
